/**
 * @file Redux Store 配置
 * @description 應用程式的全域狀態管理中心，使用 Redux Toolkit 配置
 */
import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';

/**
 * Redux Store 實例
 * @description 使用 configureStore 建立的全域 store，整合所有 reducers
 */
const store = configureStore({
  reducer: rootReducer
});

/** Store dispatch 方法的型別，用於 useDispatch hook 的型別推導 */
export type AppDispatch = typeof store.dispatch;

/** 全域 state 的型別，用於 useSelector hook 的型別推導 */
export type RootState = ReturnType<typeof store.getState>;

export default store;
